// extracted by mini-css-extract-plugin
export default {"GateBody":"json_GateBody__V1zgv","SettingsContainer":"json_SettingsContainer__3x5Ny","InputContainer":"json_InputContainer__Dx3NE","Button":"json_Button__QN7B8"};